import React from "react";
import styled from "styled-components";

export const Logo = styled.img`
  width: 25px;
  height: 25px;
  // margin :${(props) => (props.left ? "0 10px 0 0" : "0 0 0 10px")};
`;
export const MediumImage = styled.img`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin: 0 10px 0 20px;
`;

export const Input = styled.input`
	width:100%;
	height:30px;
    margin: 5px 0 0;
    border-radius: 6px;
    background: #ecf0f1;
    border:none;
    &:focus {
        outline: none;
        border:solid 1px #ecf0f1;
        border-bottom: 2px solid #009b61;
        background: #ffffff;
    }
  }
        `;

export const Label = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;
  // color: #273e4c;
`;

export const SmallIcon = styled.img`
  width: ${(props) => (props.medium ? "17px" : "12px")};
  height: ${(props) => (props.medium ? "17px" : "12px")};
  margin: ${(props) =>
    props.left ? "0 10px 0 0" : props.margin ? "0 0 0 5px" : "0 0 0 10px"};
`;
export const Button = styled.button`
  /* Adapt the colors based on primary prop */
  background: ${(props) =>
    props.primary
      ? "#ecf0f1"
      : props.success
      ? "#009b61"
      : props.black
      ? "#273e4c"
      : "white"};
  color: ${(props) =>
    props.primary
      ? "#0e0f11"
      : props.success
      ? "white"
      : props.black
      ? "white"
      : "#0e0f11"};
  height: ${(props) => (props.height ? "47px" : "auto")};
  width: ${(props) => (props.width ? "100%" : "auto")};
  padding: ${(props) => (props.padding ? props.padding : "6px")};
  border: none;
  border-radius: 6px;
  font-family: Inter;
  cursor: pointer;
  font-size: 12px;
  font-weight: ${(props) => (props.font_weight ? "500" : "normal")};
  box-shadow: ${(props) =>
    props.box_shadow ? "0 2px 2px 0 rgba(146, 154, 171, 0.2)" : ""};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  &:hover {
    background: ${(props) =>
      props.primary
        ? "#dee2e3"
        : props.success
        ? "#1c7151"
        : props.black
        ? "#273e4c"
        : "#ecf0f1"};
    color: ${(props) =>
      props.primary
        ? "#0e0f11"
        : props.success
        ? "white"
        : props.black
        ? "white"
        : "#0e0f11"};
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => (props.switch ? "none" : " 0px 0px 2px #009b61")};
  }
`;
export const CheckBoxWrapper = styled.div`
  position: relative;
  margin: 0px 0px 0px 10px;
`;
export const CheckBoxLabel = styled.label`
  margin: 0;
  position: absolute;
  top: 3px;
  left: 5px;
  width: 20px;
  height: 12px;
  border-radius: 15px;
  background: #bebebe;
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    margin-top: 0.8px;
    margin-left: 1px;
    background: #ffffff;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`;
export const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 20px;
  height: 12px;
  &:checked + ${CheckBoxLabel} {
    background: #009b61;
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 10px;
      height: 10px;
      margin-left: 8.5px;
      margin-top: 0.8px;
      transition: 0.2s;
    }
  }
`;
